// extracted by mini-css-extract-plugin
module.exports = {"order":"reading_order__2-p0U","container":"reading_container__36pui","margin":"reading_margin__3oyy-","padding":"reading_padding__1XSCY","table":"reading_table__Xj4WB"};